document.addEventListener("DOMContentLoaded", () => {
    const container = document.querySelector("#compare-container");
    if (!container) return;

    const getList = () => {
        try { return JSON.parse(localStorage.getItem("compareProducts")) || []; }
        catch { return []; }
    };

    async function renderCompare() {
        const list = getList();
        console.log(list)
        if (!list.length) {
            const msg = document.querySelector("#compare-container").dataset.emptyMessage;
            container.innerHTML = "<p>" + msg + "</p>";
            return;
        }

        container.innerHTML = "";

        for (const item of list) {
            const res = await fetch(`/products/${item.handle}?variant=${item.variantId}&section_id=compare-product-card`);
            const html = await res.text();

            container.insertAdjacentHTML("beforeend", html);
        }
    }

    renderCompare();

});


document.addEventListener("click", (e) => {
    if (!e.target.closest(".material-dropdown")) {
        document.querySelectorAll(".material-options").forEach(opt => opt.style.display = "none");
    }
});

document.addEventListener("click", (e) => {
    // Toggle material dropdown
    if (e.target.closest(".material-selected")) {
        const dropdown = e.target.closest(".material-dropdown");
        dropdown.querySelector(".material-options").style.display =
            dropdown.querySelector(".material-options").style.display === "none" ? "block" : "none";

        const options = dropdown.querySelector(".material-options");
        const isOpen = options.style.display === "block";
        dropdown.classList.toggle("open", isOpen);
    }

    // Select material
    if (e.target.matches(".material-option")) {
        const wrapper = e.target.closest(".compare-card");
        const handle = wrapper.dataset.handle;
        const variants = JSON.parse(wrapper.dataset.variants);
        const selectedMaterial = e.target.dataset.material;


        const activeColor = wrapper.querySelector(".swatch.active")?.dataset.color;
        let variant = variants.find(v => v.material === selectedMaterial && v.color === activeColor);
        if (!variant) {
            variant = variants.find(v => v.material === selectedMaterial);
        }

        fetch(`/products/${handle}?section_id=compare-product-card&variant=${variant.id}`)
            .then(res => res.text())
            .then(html => wrapper.outerHTML = html);
    }

    // Select color
    if (e.target.matches(".swatch")) {
        const wrapper = e.target.closest(".compare-card");
        const handle = wrapper.dataset.handle;
        const variants = JSON.parse(wrapper.dataset.variants);
        const selectedColor = e.target.dataset.color;
        const selectedMaterial = wrapper.querySelector(".material-option.active")?.dataset.material;

        let variant = variants.find(v => v.material === selectedMaterial && v.color === selectedColor);

        fetch(`/products/${handle}?section_id=compare-product-card&variant=${variant.id}`)
            .then(res => res.text())
            .then(html => wrapper.outerHTML = html);
    }


    // Remove compare item
    if (e.target.matches(".compare-remove")) {
        const btn = e.target;
        const vid = btn.dataset.variant;
        const card = btn.closest(".compare-card");

        let compareList = JSON.parse(localStorage.getItem("compareProducts") || "[]");
        compareList = compareList.filter(item => item.variantId !== vid);
        localStorage.setItem("compareProducts", JSON.stringify(compareList));

        card.remove();
    }
});
